"use client";

import Link from "next/link";
import { Button } from "react-bootstrap";

export default function BuzzOnLinkedinClientPage() {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center text-center h-100 py-5">
      {/* <h1>Comming Soon!</h1> */}
      <h2 className="py-5">This page is under construction!</h2>
      <Link href={"/"}>
        <Button
          className="bg-info"
          style={{
            padding: "10px 15px",
            color: "white",
          }}
        >
          Go Home!
        </Button>
      </Link>
    </div>
  );
}
